// @flow

import styled from 'styled-components';

export default styled.span`
  display: inline-block;
  font-size: ${props => props.fontSize || '14px'};
  font-weight: ${props => (props.bold ? 'bold' : 'normal')};
  color: ${props => props.theme[props.themeColor] || props.color || '#FFF'};
  letter-spacing: ${props => props.letterSpacing || 'normal'};
  text-align: ${props => props.textAlign || 'left'};
  opacity: ${props => props.opacity || 1};
  line-height: ${props => props.lineHeight || 'normal'};
  font-family: 'Open Sans';
  font-style: ${props => (props.italic ? 'italic' : 'normal')};
`;
